import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Heading } from "grommet";
import * as React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { usePermission } from "../account/AccountStore";
import CustomButton from "../components/CustomButton";
import SkeletonWrapper from "../components/SkeletonWrapper";
import CreateSeedMatch from "./CreateSeedMatch";
import { getSeedMatches, SeedMatchViewModel } from "./SeedMatchesStore";
import SeedMatchProfile from "./SeedMatchProfile";
import { SeedMatchRow } from "./SeedMatchRow";

export const newSeedIcon = (
    <span className="fa-layers fa-fw">
        {/* @ts-ignore */}
        <FontAwesomeIcon size="lg" icon={["fad", "chart-scatter-3d"]}></FontAwesomeIcon>
        <FontAwesomeIcon icon={["fad", "plus"]} swapOpacity transform="up-15 right-15" />
    </span>
);

/* @ts-ignore */
const archive = <FontAwesomeIcon size="xl" icon={["fad", "archive"]}></FontAwesomeIcon>;

const SeedMatchesManagement = () => {
    const [seedMatches, setSeedMatches] = React.useState([] as SeedMatchViewModel[]);
    const [loading, setLoading] = React.useState(true);

    let { pathname } = useLocation();

    const [showArchive, setShowArchive] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        getSeedMatches(showArchive).then((seedMatches) => {
            setSeedMatches(seedMatches);
            setLoading(false);
        });
    }, [pathname, showArchive]);

    const hasWritePermission = usePermission("sport:seedMatches.write");

    return (
        <div>
            <Routes>
                <Route path={"create"} element={<>{hasWritePermission && <CreateSeedMatch />}</>}></Route>
                <Route path={":id/*"} element={<SeedMatchProfile />}></Route>
                <Route
                    path={""}
                    element={
                        <>
                            <Heading size="small">Seed Matches</Heading>
                            <Box direction="row" pad={"small"} gap="small">
                                {hasWritePermission && <CustomButton path={"/seedMatches/create"} icon={newSeedIcon} label="New Seed Match"></CustomButton>}
                                <CustomButton primary={showArchive} icon={archive} label={showArchive ? "Show Active" : "Show Archive"} onClick={() => setShowArchive(!showArchive)}></CustomButton>
                            </Box>
                            <SkeletonWrapper loading={loading}>
                                <Box gap="small">
                                    {seedMatches.map((seedMatch) => (
                                        <SeedMatchRow key={seedMatch.id} seedMatch={seedMatch}></SeedMatchRow>
                                    ))}
                                </Box>
                            </SkeletonWrapper>
                        </>
                    }
                ></Route>
            </Routes>
        </div>
    );
};

export default SeedMatchesManagement;
